export const GroupSocial = () => {
  return (
    <div className="groupSocial">
      <div className="container">
        <a
          href="https://www.facebook.com/oncfpageofficielle"
          className="lineSocial fac"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13px"
            height="24px"
            viewBox="0 0 13 24"
            version="1.1"
            className="injected-svg"
            data-src="https://www.oncf-voyages.ma/media/static/fr/images/icone-facebook.svg"
          >
            <title>Facebook</title>
            <desc>Created with Sketch.</desc>
            <g
              id="Symbols"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g
                id="footer"
                transform="translate(-358.000000, -108.000000)"
                fill="#BEB3D5"
              >
                <g id="rs">
                  <g transform="translate(358.000000, 108.000000)">
                    <path
                      d="M8.43818099,24 L8.43818099,13.0524372 L12.270951,13.0524372 L12.844854,8.78597774 L8.43818099,8.78597774 L8.43818099,6.06211294 C8.43818099,4.82687447 8.79595501,3.98510021 10.6435197,3.98510021 L13,3.98411298 L13,0.168157408 C12.5924557,0.116163532 11.1936245,0 9.56619317,0 C6.16865572,0 3.84260971,1.98827213 3.84260971,5.63958043 L3.84260971,8.78597774 L0,8.78597774 L0,13.0524372 L3.84260971,13.0524372 L3.84260971,24 L8.43818099,24 Z"
                      id="Facebook-17"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </a>
        <a href="https://twitter.com/ONCFgroup" className="lineSocial twt">
          <div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30px"
                height="24px"
                viewBox="0 0 30 24"
                version="1.1"
                className="injected-svg"
                dataSrc="https://www.oncf-voyages.ma/media/static/fr/images/icone-twitter.svg"
              >
                <title>Twitter-color</title>
                <desc>Created with Sketch.</desc>
                <g
                  id="Symbols"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="footer"
                    transform="translate(-391.000000, -108.000000)"
                    fill="#BEB3D5"
                  >
                    <g id="rs">
                      <g transform="translate(358.000000, 108.000000)">
                        <path
                          d="M63,2.8411701 C61.8976933,3.32307692 60.7108646,3.64897075 59.4659271,3.79458288 C60.7372777,3.04572048 61.7128015,1.85828819 62.1723895,0.443770314 C60.9820391,1.13716143 59.6666667,1.64160347 58.2614897,1.912026 C57.1415742,0.734994583 55.5409403,0 53.7695017,0 C50.3727769,0 47.61701,2.71289274 47.61701,6.05850488 C47.61701,6.53347779 47.6698362,6.99458288 47.7754886,7.4383532 C42.6601514,7.18526544 38.1259024,4.77573131 35.0883958,1.10595883 C34.558373,2.00390033 34.2555027,3.04572048 34.2555027,4.15514626 C34.2555027,6.25612134 35.3419616,8.11094258 36.9936609,9.19783315 C35.9864413,9.16836403 35.0355696,8.89274106 34.2044374,8.44203684 L34.2044374,8.51657638 C34.2044374,11.4530878 36.3262898,13.9024919 39.1436873,14.4572048 C38.6277514,14.5993499 38.0836415,14.6704225 37.5219229,14.6704225 C37.1257264,14.6704225 36.7383342,14.6340195 36.3632682,14.5629469 C37.1468568,16.9690141 39.4183835,18.7215601 42.1125198,18.768364 C40.0065152,20.3943662 37.3511182,21.3633803 34.4685684,21.3633803 C33.9720021,21.3633803 33.4807184,21.3356446 33,21.2801733 C35.7240711,22.9963164 38.9605564,24 42.4347596,24 C53.7571756,24 59.9466455,14.7692308 59.9466455,6.76229686 C59.9466455,6.49880823 59.9413629,6.23531961 59.9307977,5.97703142 C61.1334742,5.12242687 62.1776721,4.05633803 63,2.8411701"
                          id="Twitter-18"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </a>
        <a
          href="https://www.instagram.com/groupe_oncf/"
          className="lineSocial ins"
        >
          <div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
                className="injected-svg"
                dataSrc="https://www.oncf-voyages.ma/media/static/fr/images/icone-instagram.svg"
              >
                <title>Instagram-color</title>
                <desc>Created with Sketch.</desc>
                <g
                  id="Symbols"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                >
                  <g
                    id="footer"
                    transform="translate(-485.000000, -108.000000)"
                    fill="#BEB3D5"
                  >
                    <g id="rs">
                      <g transform="translate(358.000000, 108.000000)">
                        <path
                          d="M140.16042,0.000809680479 C142.383468,0.00447633281 142.838314,0.0216004652 143.947585,0.0722132578 C145.224845,0.130469732 146.097168,0.333343257 146.860456,0.630008276 C147.649562,0.936628817 148.318773,1.34694874 148.985936,2.01406396 C149.653051,2.68122682 150.063371,3.35043794 150.370039,4.13954402 C150.666657,4.90283244 150.86953,5.77515526 150.927787,7.05241535 C150.9784,8.16168593 150.995524,8.61653228 150.99919,10.8396109 L150.99919,13.1604201 C150.995524,15.3834677 150.9784,15.8383141 150.927787,16.9475847 C150.86953,18.2248447 150.666657,19.0971676 150.370039,19.860456 C150.063371,20.6495621 149.653051,21.3187732 148.985936,21.985936 C148.318773,22.6530513 147.649562,23.0633712 146.860456,23.3700394 C146.097168,23.6666567 145.224845,23.8695303 143.947585,23.9277867 C142.667657,23.9861861 142.259004,24 139.000024,24 C135.740996,24 135.332343,23.9861861 134.052415,23.9277867 C132.775155,23.8695303 131.902832,23.6666567 131.139544,23.3700394 C130.350438,23.0633712 129.681227,22.6530513 129.014064,21.985936 C128.346949,21.3187732 127.936629,20.6495621 127.630008,19.860456 C127.333343,19.0971676 127.13047,18.2248447 127.072213,16.9475847 C127.0216,15.8383141 127.004476,15.3834677 127.00081,13.1604201 L127.00081,10.8396109 C127.004476,8.61653228 127.0216,8.16168593 127.072213,7.05241535 C127.13047,5.77515526 127.333343,4.90283244 127.630008,4.13954402 C127.936629,3.35043794 128.346949,2.68122682 129.014064,2.01406396 C129.681227,1.34694874 130.350438,0.936628817 131.139544,0.630008276 C131.902832,0.333343257 132.775155,0.130469732 134.052415,0.0722132578 C135.161686,0.0216004652 135.616532,0.00447633281 137.839611,0.000809680479 Z M140.139818,2.16289002 L137.860213,2.16289002 C135.67891,2.16623154 135.247608,2.18209792 134.15097,2.23213276 C132.980982,2.28548292 132.345591,2.48097316 131.922743,2.64531072 C131.362614,2.86299845 130.962869,3.12303286 130.542975,3.54297487 C130.123033,3.96286924 129.862998,4.3626144 129.645311,4.92274348 C129.480973,5.34559117 129.285483,5.9809821 129.232133,7.15097025 C129.182098,8.24760827 129.166232,8.67890963 129.16289,10.8602129 L129.16289,13.1398181 C129.166232,15.3210904 129.182098,15.7523917 129.232133,16.8490298 C129.285483,18.0190179 129.480973,18.6544088 129.645311,19.0772565 C129.862998,19.6373856 130.12308,20.0371308 130.542975,20.4570251 C130.962869,20.8769671 131.362614,21.1370016 131.922743,21.3546893 C132.345591,21.5190268 132.980982,21.7145171 134.15097,21.7678672 C135.247484,21.8179021 135.678698,21.8337685 137.860135,21.83711 L140.139898,21.83711 C142.321313,21.8337685 142.752557,21.8179021 143.84903,21.7678672 C145.019018,21.7145171 145.654409,21.5190268 146.077257,21.3546893 C146.637386,21.1370016 147.037131,20.8769671 147.457025,20.4570251 C147.876967,20.0371308 148.137002,19.6373856 148.354689,19.0772565 C148.519027,18.6544088 148.714517,18.0190179 148.767867,16.8490298 C148.817902,15.7523917 148.833768,15.3210904 148.83711,13.1398181 L148.83711,10.8602129 C148.833768,8.67890963 148.817902,8.24760827 148.767867,7.15097025 C148.714517,5.9809821 148.519027,5.34559117 148.354689,4.92274348 C148.137002,4.3626144 147.876967,3.96286924 147.457025,3.54297487 C147.037131,3.12303286 146.637386,2.86299845 146.077257,2.64531072 C145.654409,2.48097316 145.019018,2.28548292 143.84903,2.23213276 C142.752392,2.18209792 142.32109,2.16623154 140.139818,2.16289002 Z M139.000024,5.8378417 C142.403288,5.8378417 145.162158,8.59671206 145.162158,12.0000238 C145.162158,15.4032879 142.403288,18.1621583 139.000024,18.1621583 C135.596712,18.1621583 132.837842,15.4032879 132.837842,12.0000238 C132.837842,8.59671206 135.596712,5.8378417 139.000024,5.8378417 Z M139.000024,8 C136.790851,8 135,9.79085069 135,12.0000238 C135,14.2091493 136.790851,16 139.000024,16 C141.209149,16 143,14.2091493 143,12.0000238 C143,9.79085069 141.209149,8 139.000024,8 Z M145.405616,4.15435822 C146.200915,4.15435822 146.845642,4.79908543 146.845642,5.59438394 C146.845642,6.38968246 146.200915,7.03436203 145.405616,7.03436203 C144.610365,7.03436203 143.965638,6.38968246 143.965638,5.59438394 C143.965638,4.79908543 144.610365,4.15435822 145.405616,4.15435822 Z"
                          id="Instagram-19"
                        ></path>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </a>
        <a
          href="https://www.youtube.com/user/oncfchaineofficielle"
          className="lineSocial ytb"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="34px"
            height="24px"
            viewBox="0 0 34 24"
            version="1.1"
            className="injected-svg "
            dataSrc="https://www.oncf-voyages.ma/media/static/fr/images/icone-youtube.svg"
          >
            <title>Youtube-color</title>
            <desc>Created with Sketch.</desc>
            <g
              id="Symbols"
              stroke="none"
              strokeWidth="1"
              fill="none"
              fillRule="evenodd"
            >
              <g
                id="footer"
                transform="translate(-529.000000, -108.000000)"
                fill="#BEB3D5"
              >
                <g id="rs">
                  <g transform="translate(358.000000, 108.000000)">
                    <path
                      d="M184.4895,16.4258231 L184.488438,6.83840583 L193.674813,11.6486426 L184.4895,16.4258231 Z M204.66,5.17705603 C204.66,5.17705603 204.327437,2.82578753 203.3085,1.79037633 C202.015437,0.430799307 200.566187,0.424401297 199.902125,0.345492513 C195.14425,0 188.007437,0 188.007437,0 L187.992562,0 C187.992562,0 180.85575,0 176.097875,0.345492513 C175.43275,0.424401297 173.984563,0.430799307 172.690438,1.79037633 C171.6715,2.82578753 171.34,5.17705603 171.34,5.17705603 C171.34,5.17705603 171,7.93886346 171,10.6996046 L171,13.2886657 C171,16.0504732 171.34,18.8112143 171.34,18.8112143 C171.34,18.8112143 171.6715,21.1624828 172.690438,22.197894 C173.984563,23.557471 175.6835,23.5148176 176.44,23.6566402 C179.16,23.9189585 188,24 188,24 C188,24 195.14425,23.9893367 199.902125,23.6438441 C200.566187,23.563869 202.015437,23.557471 203.3085,22.197894 C204.327437,21.1624828 204.66,18.8112143 204.66,18.8112143 C204.66,18.8112143 205,16.0504732 205,13.2886657 L205,10.6996046 C205,7.93886346 204.66,5.17705603 204.66,5.17705603 L204.66,5.17705603 Z"
                      id="Youtube-20"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </a>
        <a
          href="https://wa.me/212667652255?text=Bonjour%20M%27ONCF"
          className="watsapSvg lineSocial"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30px"
            height="30px"
            viewBox="0 0 30 30"
            version="1.1"
            className="injected-svg"
            dataSrc="https://www.oncf-voyages.ma/media/static/fr/images/icone-whatsapp.svg"
          >
            <g id="surface1">
              <path
                d="M 22.875 7.253906 C 20.867188 5.246094 18.199219 4.140625 15.359375 4.140625 C 9.503906 4.140625
                    4.738281 8.90625 4.734375 14.761719 C 4.734375 16.636719 5.222656 18.460938 6.152344 
                    20.074219 L 4.644531 25.578125 L 10.277344 24.101562 C 11.828125 24.949219 13.574219 25.394531 
                    15.355469 25.394531 L 15.359375 25.394531 C 21.214844 25.394531 25.980469 20.628906 25.980469 
                    14.769531 C 25.984375 11.933594 24.878906 9.261719 22.875 7.253906 Z M 15.359375 23.601562 L 
                    15.355469 23.601562 C 13.769531 23.601562 12.214844 23.175781 10.859375 22.371094 L 10.539062 
                    22.179688 L 7.195312 23.054688 L 8.089844 19.796875 L 7.878906 19.460938 C 6.996094 18.054688 6.527344 
                    16.429688 6.527344 14.761719 C 6.53125 9.894531 10.492188 5.933594 15.363281 5.933594 C 17.71875 5.933594 
                    19.9375 6.855469 21.605469 8.523438 C 23.273438 10.191406 24.1875 12.410156 24.1875 14.769531 C 24.1875 
                    19.640625 20.226562 23.601562 15.359375 23.601562 Z M 20.203125 16.988281 C 19.9375 16.855469 18.632812 
                    16.210938 18.386719 16.125 C 18.144531 16.035156 17.96875 15.992188 17.789062 16.257812 C 17.613281 
                    16.523438 17.105469 17.121094 16.949219 17.296875 C 16.796875 17.472656 16.640625 17.496094 16.375 
                    17.363281 C 16.109375 17.230469 15.253906 16.949219 14.242188 16.046875 C 13.453125 15.34375 12.917969 
                    14.472656 12.761719 14.207031 C 12.609375 13.941406 12.746094 13.796875 12.878906 13.664062 C 13 13.546875 
                    13.144531 13.355469 13.277344 13.199219 C 13.410156 13.046875 13.457031 12.933594 13.542969 12.757812 C 
                    13.632812 12.582031 13.589844 12.425781 13.523438 12.292969 C 13.457031 12.160156 12.925781 10.851562 
                    12.703125 10.320312 C 12.488281 9.804688 12.269531 9.875 12.105469 9.867188 C 11.953125 9.859375 11.773438 
                    9.855469 11.597656 9.855469 C 11.421875 9.855469 11.132812 9.921875 10.890625 10.1875 C 10.644531 
                    10.453125 9.960938 11.097656 9.960938 12.402344 C 9.960938 13.710938 10.910156 14.972656 11.042969 
                    15.148438 C 11.175781 15.324219 12.914062 18.007812 15.578125 19.15625 C 16.210938 19.429688 16.707031 
                    19.59375 17.09375 19.714844 C 17.726562 19.917969 18.308594 19.890625 18.765625 19.820312 C 19.273438 
                    19.746094 20.335938 19.179688 20.554688 18.558594 C 20.777344 17.9375 20.777344 17.40625 20.710938 
                    17.296875 C 20.644531 17.1875 20.46875 17.121094 20.203125 16.988281 Z M 20.203125 16.988281 "
              ></path>
            </g>
          </svg>
        </a>
      </div>
    </div>
  );
};
